import { ReactNode } from 'react';
import { cn } from '@/lib/utils.ts';

const TwoInputsRow = ({
  ratio = '1/1',
  children,
  className,
}: {
  ratio?: '2/1' | '3/1' | '1/1' | '1/2' | '1/3';
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'grid gap-4',
        {
          'md:grid-cols-2': ratio === '1/1',
          'md:grid-cols-[1fr_2fr]': ratio === '1/2',
          'md:grid-cols-[1fr_3fr]': ratio === '1/3',
          'md:grid-cols-[2fr_1fr]': ratio === '2/1',
          'md:grid-cols-[3fr_1fr]': ratio === '3/1',
        },
        className,
      )}
    >
      {children}
    </div>
  );
};

export default TwoInputsRow;
